import React, { useEffect, useState } from 'react';
import { Styles } from '../styles/courseCategory.js';
// import Services from '../../../services/service'; // Unused
import { useDispatch } from 'react-redux';
import { categoryData } from '../../../redux-files/Actions/courseTypeAction';
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import learnerService from '../../../services/learnerService';
import UserService from '../../../services/UserService.js';

const languages = [
    { code: 'en', name: 'English', country_code: 'gb' },
]

const CourseCategory = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation()
    
    // Better initial state: an empty array
    const [category, setCategory] = useState([]); 

    useEffect(() => {
        UserService.generateToken();
    }, []);

    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    
    useEffect(() => {
        document.body.dir = currentLanguage?.dir ?? "ltr";
        document.title = t('app_title')
    }, [currentLanguage, t])

    useEffect(() => {
        learnerService.getPublishCourses()
            .then(res => {
                // Move these inside useEffect so they don't recreate on every render
                let catArray = [];
                let categoryCountMap = {};
                let totalCourses = res.data ? res.data.length : 0;

                // 1. ADD DEFAULT "ALL" CATEGORY FIRST
                catArray.push({ 
                    categoryName: 'All', // Or use t('all_categories') if you have it in translation
                    categoryLength: totalCourses 
                });

                // 2. Count courses per category
                res.data.forEach((data) => {
                    if (categoryCountMap[data.categoryName] === undefined) {
                        categoryCountMap[data.categoryName] = 1;
                    } else {
                        categoryCountMap[data.categoryName]++;
                    }
                });

                // 3. Push the rest of the categories to the array
                for (let key in categoryCountMap) {
                    if (key && key !== 'undefined') { // Safety check to avoid empty category names
                        catArray.push({ categoryName: key, categoryLength: categoryCountMap[key] });
                    }
                }
                
                setCategory(catArray);
            })
            .catch(err => {
                console.error("Error fetching courses", err);
            });
    }, []);

    const categoryHandler = (value) => {
        // If "All" is selected, you might want to pass an empty string "" 
        // to your Redux action depending on how your filter logic works.
        const filterValue = value === 'All' ? '' : value; 
        dispatch(categoryData(filterValue));
    }

    return (
        <Styles>
            <div className="course-category">
                <h5>{t('course_category')}</h5>
                <ul className="category-item list-unstyled ">
                    {category.map((data, i) => {
                        return (
                            <li key={i} className="check-btn shadow-sm rounded">
                                <label style={{ marginLeft: "10px", marginTop: "5px" }} className='catLabel'>
                                    <input 
                                        type="radio" 
                                        name="category" 
                                        className="form-check-input" 
                                        value={data.categoryName} 
                                        defaultChecked={data.categoryName === 'All'} // Automatically checks "All" on load
                                        onClick={() => categoryHandler(data.categoryName)} 
                                    />
                                    {/* Translate 'All' to local language, otherwise show category name */}
                                    {data.categoryName === 'All' ? t('all') || 'All' : data.categoryName}
                                    <span>
                                        ({data.categoryLength})
                                    </span>
                                </label>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </Styles>
    )
}

export default CourseCategory;